import WidgetTextFullPresentation from 'components/WidgetTextFull/WidgetTextFullPresentation'

export default {
  Presentation: WidgetTextFullPresentation,
}
